<template>
    <div>
			<div class="font-weight-prop col-xs-12 p-0">
					<div class="sub-approval" v-if=showInAccountsFilter>Date Range</div>
			</div>
      <div class="date-picker col-xs-12 p-0 m-0"  v-if="!disabledDate">
        <div class="alert-menu col-xs-12 p-0 m-0">
        <date-picker ref="datePickers"
            :lang="this.$i18n.locale === 'English' ? getEnglishPicker : getPortuguesePicker"
            v-model="start_approval_date"
            :default-value="
            start_approval_date ? start_approval_date : new Date()
            "
            :disabled-date="notBeforeApprovalEndDate"
            :editable="true"
            type="date"
            :placeholder="this.$i18n.locale === 'English' ?$t('englishDatePlaceholder') :$t('portugueseDatePlaceholder')"
            :format="formatStartDate"
            @change="isValidStartDate('start')"
        >
          <i slot="icon-calendar">
            <img src="/static/images/icons/date-picker-calender-icon.svg" alt="calender-icon">
          </i>
        </date-picker>
        </div>
        <div class="col-xs-12 p-0 d-flex justify-content-center fw-600 font-12 to-text-section">
          {{ $t('to') }}
        </div>
        <!-- <div class="col-xs-12 p-0 m-0 to-text-section text-center">
          <div class="start-to-end fw-400 font-14">
            {{ $t('to') }}
          </div>
        </div> -->
        <div class="alert-menu col-xs-12 p-0 m-0 pb-16">
          <date-picker
              v-model="end_approval_date"
              :lang="this.$i18n.locale === 'English' ? getEnglishPicker : getPortuguesePicker"
              :disabled-date="notBeforeApprovalStartDate"
              :default-value="
              end_approval_date ? end_approval_date : new Date()
              "
              :editable="true"
              type="date"
              :placeholder="this.$i18n.locale === 'English' ?$t('englishDatePlaceholder') :$t('portugueseDatePlaceholder')"
              :format="formatEndDate"
              @change="isValidStartDate('end')"

          >
          <i slot="icon-calendar">
            <img src="/static/images/icons/date-picker-calender-icon.svg" alt="calender-icon">
          </i>
        </date-picker>
        </div>
      </div>
    </div>
</template>

<script>
import moment from 'moment';
import DatePicker from 'vue2-datepicker';
import EventBus from '../../utils/event-bus';
import translation from './mixins/translationMixins';

export default {
  // props: ['dateFormat', 'eventType', 'label'],
  props: {
    dateFormat: {
      type: String,
      default: 'YYYY-MM-DD',
    },
    eventType: {
      type: String,
    },
    label: {
      type: String,
    },
    showInAccountsFilter: {
      type: Boolean,
    },
    disabledDate: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    DatePicker,
  },
  mixins: [translation],
  data() {
    return {
      formatStartDate: {
        stringify: (date) => (date ? moment(date).format(this.$i18n.locale === 'Portuguese' ? 'DD/MM/YYYY' : 'MM/DD/YYYY') : null),
        parse: (value) => {
          const date = moment(value, this.$i18n.locale === 'Portuguese' ? 'DD/MM/YYYY' : 'MM/DD/YYYY');
          if (!date.isValid()) {
            if (value) {
              this.start_approval_date = '';
              this.$notify({
                type: 'error',
                title: this.$i18n.locale === 'Portuguese' ? 'Erro' : 'Error',
                text:
                  this.$i18n.locale === 'Portuguese'
                    ? 'Insira uma data de início válida'
                    : 'Please enter valid start date',
                group: 'custom-notification'
              });
            }
            return '';
          }
          // eslint-disable-next-line no-underscore-dangle
          return value ? moment(date)._d : null;
        },
      },
      formatEndDate: {
        stringify: (date) => (date ? moment(date).format(this.$i18n.locale === 'Portuguese' ? 'DD/MM/YYYY' : 'MM/DD/YYYY') : null),
        parse: (value) => {
          const date = moment(value, this.$i18n.locale === 'Portuguese' ? 'DD/MM/YYYY' : 'MM/DD/YYYY');
          if (!date.isValid()) {
            if (value) {
              this.end_approval_date = '';
              this.$notify({
                type: 'error',
                title: this.$i18n.locale === 'Portuguese' ? 'Erro' : 'Error',
                text:
                  this.$i18n.locale === 'Portuguese'
                    ? 'Insira uma data de término válida'
                    : 'Please enter valid end date',
                group: 'custom-notification'
              });
            }
            return '';
          }
          // eslint-disable-next-line no-underscore-dangle
          return value ? moment(date)._d : null;
        },
      },
      start_approval_date: '',
      end_approval_date: '',
      isDateRangeSelected: false,
    };
  },

  mounted() {
    EventBus.$on(`setCustomDatesFor${this.eventType}`, (dateRange) => {
      this.start_approval_date = moment(dateRange.startDate).format(this.dateFormat);
      this.end_approval_date = moment(dateRange.endDate).format(this.dateFormat);
      this.isDateRangeSelected = true;
    });
    EventBus.$on(`normalDatesSelected${this.eventType}`, () => {
      this.setDefaultDateValues();
    });
    EventBus.$on('clearAllCustomDates', () => {
      this.setDefaultDateValues();
    });
  },

  beforeDestroy() {
    EventBus.$off(`normalDatesSelected${this.eventType}`);
    EventBus.$off(`setCustomDatesFor${this.eventType}`);
    EventBus.$off('clearAllCustomDates');
  },

  methods: {
    notBeforeApprovalEndDate(date) {
      if (this.end_approval_date) {
        return date > new Date(this.end_approval_date).setHours(0, 0, 0, 0);
      }
      return '';
    },

    notBeforeApprovalStartDate(date) {
      return date < new Date(this.start_approval_date).setHours(0, 0, 0, 0);
    },
    isValidStartDate(type) {
      const time1 = this.start_approval_date ? moment(this.start_approval_date).format('YYYY-MM-DD') : '';
      const time2 = this.end_approval_date ? moment(this.end_approval_date).format('YYYY-MM-DD') : '';
      if (type === 'start' && time1 && time2 && time1 > time2) {
        this.$notify({
          type: 'error',
          title: this.$i18n.locale === 'Portuguese' ? 'Erro' : 'Error',
          text:
            this.$i18n.locale === 'Portuguese'
              ? 'Insira a data de início menor ou igual à data de término'
              : 'Please enter start date less than or equal to end date',
          group: 'custom-notification'
        });
        return;
      }
      if (type === 'end' && time1 && time2 && time2 < time1) {
        this.$notify({
          type: 'error',
          title: this.$i18n.locale === 'Portuguese' ? 'Erro' : 'Error',
          text:
            this.$i18n.locale === 'Portuguese'
              ? 'Insira uma data final maior ou igual à data inicial'
              : 'Please enter end date greater than or equal to start date',
          group: 'custom-notification'
        });
        return;
      }
      this.onDateRangeSelection();
    },
    onDateRangeSelection() {
      if (this.start_approval_date && this.end_approval_date) {
        let dateRange;
        if (this.label === 'records') {
          dateRange = {
            from: new Date(moment(this.start_approval_date).format(this.dateFormat)).toISOString(),
            to: new Date(moment(this.end_approval_date).format(this.dateFormat)).toISOString(),
          };
        } else {
          dateRange = {
            from: moment(this.start_approval_date).format(this.dateFormat),
            to: moment(this.end_approval_date).format(this.dateFormat),
          };
        }
        this.isDateRangeSelected = true;
        this.$emit('dateRange', dateRange);
      } else if (this.isDateRangeSelected) {
        if (!this.start_approval_date || !this.end_approval_date) {
          this.isDateRangeSelected = false;
          this.clearDateRangeInFilter();
        }
      }
    },

    clearDateRangeInFilter() {
      const dateRange = {};
      this.$emit('dateRange', dateRange);
    },

    setDefaultDateValues() {
      if (this.start_approval_date || this.end_approval_date) {
        this.isDateRangeSelected = false;
        this.start_approval_date = '';
        this.end_approval_date = '';
      }
    },
  },
};
</script>
<style>
.mx-datepicker-main .mx-table-date thead tr th {
  font-size: 14px;
  color: #333333;
  font-weight: 700;
  height: 32px;
  /* line-height: 19px;
  text-align: center;
  /* text-transform: uppercase; */
}

.mx-datepicker-main .mx-btn.mx-btn-current-month {
  font-size: 14px;
  color: #333333;
  font-weight: 700;
}
.mx-datepicker-main .mx-btn.mx-btn-current-year {
  font-size: 14px;
  color: #333333;
  font-weight: 700;
}
.mx-datepicker-main .mx-btn .mx-icon-double-left:before {
    border-color: #333333;
      border-width: 3px 0 0px 3px;
}
.mx-datepicker-main .mx-btn .mx-icon-double-left:after {
  border-color: #333333;
  border-width: 3px 0 0px 3px;
}
.mx-datepicker-main .mx-btn .mx-icon-left:before {
  border-color: #333333;
  border-width: 3px 0 0px 3px;
}

.mx-datepicker-main .mx-btn .mx-icon-left:after {
  border-color: #333333;
  border-width: 3px 0 0px 3px;
}
.mx-datepicker-main .mx-btn .mx-icon-double-right:before {
  border-color: #333333;
  border-width: 3px 0 0px 3px;
}

.mx-datepicker-main .mx-btn .mx-icon-double-right:after {
  border-color: #333333;
  border-width: 3px 0 0px 3px;
}

.mx-datepicker-main .mx-btn .mx-icon-right:before {
  border-color: #333333;
  border-width: 3px 0 0px 3px;
}

.mx-datepicker-main .mx-btn .mx-icon-right:after {
  border-color: #333333;
  border-width: 3px 0 0px 3px;
}
.mx-datepicker-main .cell.active {
  color: #fff;
  /* background-color: #001524 !important; */
}
.mx-date-row .cell:hover {
  color: #fff !important;
  background-color: #001524 !important;
}
</style>

<style scoped>
.pb-16{
padding-bottom: 16px;
}
.to-text-section{
  color: #4D4D4D;
  font-size: 14px;
  padding: 8px 0px;
}

.alert-menu .mx-datepicker {
  width: 136px;
}

.alert-menu .mx-datepicker >>> .mx-input::placeholder {
  color: #4D4D4D;
  font-weight: 400;
  font-size: 16px;
}
.alert-menu .mx-datepicker >>> .mx-input {
padding: 5px 0px 5px 35px;
background: #FFFFFF;
/* border: 0.5px solid #4D4D4D; */
border: 1px solid #4D4D4D;
border-radius: 3px;
height: 34px;
font-family: 'Open Sans';
font-style: normal;
font-size: 16px;
line-height: 18px;
color: #4D4D4D;
}
.alert-menu .mx-datepicker >>> .mx-input-wrapper .mx-icon-calendar {
  left: 6px;
  font-size: 18px;
  top: 52%;
  right:auto
}
.alert-menu .mx-datepicker >>> .mx-input-wrapper .mx-icon-clear {
  left: 9px;
  height: 16px;
  width: 16px;
}
.alert-menu >>> .el-input--suffix .el-input__inner {
padding-right: 0px;
}

/* .alert-menu {
padding-left: 8px;
} */

.start-to-end {
line-height: 19px;
color: #333333;
}

.sub-approval {
font-family: 'Open Sans';
font-style: normal;
font-weight: 300;
font-size: 16px;
line-height: 22px;
color: #333333;
padding: 16px 0px 12px 32px;
}
.alert-menu .mx-datepicker>>>.mx-datepicker-main .mx-datepicker-content .mx-datepicker-body .mx-calendar .mx-calendar-header .mx-btn {
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  text-align: center;
  color: #333333;
}

.alert-menu .mx-datepicker  >>>.mx-datepicker-main .mx-datepicker-content .mx-datepicker-body .mx-calendar .mx-calendar-content .mx-table-date th {
  font-size: 14px;
  color: #333333;
  font-weight: 700;
  height: 32px;
  /* line-height: 19px;
  text-align: center;
  /* text-transform: uppercase; */
}

.date-picker .mx-datepicker>>>.mx-datepicker-main .mx-datepicker-content .mx-datepicker-body .mx-calendar .mx-calendar-content .mx-table .cell.active {
  color: #fff;
  background-color: #01518A;
}

.date-picker .mx-datepicker>>>.mx-datepicker-main .mx-datepicker-content .mx-datepicker-body .mx-calendar .mx-calendar-header .mx-btn .mx-icon-double-left:before {
  border-color: #333333;
  border-width: 3px 0 0px 3px;
}

.date-picker .mx-datepicker>>>.mx-datepicker-main .mx-datepicker-content .mx-datepicker-body .mx-calendar .mx-calendar-header .mx-btn .mx-icon-double-left:after {
  border-color: #333333;
  border-width: 3px 0 0px 3px;
}

.date-picker .mx-datepicker>>>.mx-datepicker-main .mx-datepicker-content .mx-datepicker-body .mx-calendar .mx-calendar-header .mx-btn .mx-icon-double-right:before {
  border-color: #333333;
  border-width: 3px 0 0px 3px;
}

.date-picker .mx-datepicker>>>.mx-datepicker-main .mx-datepicker-content .mx-datepicker-body .mx-calendar .mx-calendar-header .mx-btn .mx-icon-double-right:after {
  border-color: #333333;
  border-width: 3px 0 0px 3px;
}

.date-picker .mx-datepicker>>>.mx-datepicker-main .mx-datepicker-content .mx-datepicker-body .mx-calendar .mx-calendar-header .mx-btn .mx-icon-left:before {
  border-color: #333333;
  border-width: 3px 0 0px 3px;
}

.date-picker .mx-datepicker>>>.mx-datepicker-main .mx-datepicker-content .mx-datepicker-body .mx-calendar .mx-calendar-header .mx-btn .mx-icon-right:after {
  border-color: #333333;
  border-width: 3px 0 0px 3px;
}

.date-picker {
  width: 136px;
}
.mx-datepicker>>>.mx-input::placeholder {
  color: #1A1A1A;
  font-size: 16px;
}
</style>
